import { z } from 'zod';
import { getDataSources } from '@/services/data-sources/data-sources-service';
import {
	getDataSourcesSchema,
	GetDataSourcesContext,
	DataSourcesResult,
} from './types';
import { TOOL_NAME_GET_DATA_SOURCES, toEngineName } from '@/constants';
import { devDebug } from '@/utils/dev-debug';

/**
 * Standalone data sources engine - completely decoupled from any UI or store
 * @param params - The parameters for getting data sources (currently empty)
 * @param context - Context with tool call ID for tracking
 * @returns The data sources summary with titles and full objects
 */
export async function getDataSourcesEngine(
	params: z.infer<typeof getDataSourcesSchema>,
	context: GetDataSourcesContext,
): Promise<DataSourcesResult> {
	devDebug('engineCall', {
		engine: toEngineName(TOOL_NAME_GET_DATA_SOURCES),
		toolCallId: context.toolCallId,
	});

	const dataSources = await getDataSources(context.httpClient);

	return {
		dataSourceTitles: dataSources.map((ds) => ds.title),
		draftDataSourceTitles: dataSources
			.filter((ds) => ds.status === 'draft')
			.map((ds) => ds.title),
		dataSources,
	};
}
